import React, { ReactElement, useEffect } from 'react'
import { useLocation } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { updateFormData } from 'redux/login/actions'
import { getCurrentLanguageFromStorage } from 'helpers/translate'
import { brandImages } from 'configureBrand'
import { LocationState } from 'types/locationState'
import LoginForm, { LoginFormProps } from 'ui/organisms/LoginForm'
import EMPTY_STRING from 'const/emptyString'
import TryMeBanner from 'ui/organisms/TryMeBanner'
import { RootState } from 'redux/store'
import {
  LoginBlock,
  LoginWrapper,
  MainPromoBlock,
  PromoWrapper
} from './subcomponents'

const LoginContainer = ({ handleSubmit }: LoginFormProps): ReactElement => {
  const isIdpFlow = useSelector(
    (reduxState: RootState) => reduxState.idp.isIdpFlow
  )
  const isWebApp = useSelector(
    (reduxState: RootState) => reduxState.jwt.isWebApp
  )
  const canTryUniversalIdp = useSelector(
    (reduxState: RootState) => reduxState.akamaiConfig.canTryUniversalIdp
  )

  const language = getCurrentLanguageFromStorage()
  const dispatch = useDispatch()
  const location = useLocation<Partial<LocationState>>()
  const userIdFromState = location.state?.userId || ''
  const canShowTryMeBanner = isIdpFlow && isWebApp && canTryUniversalIdp

  useEffect(() => {
    if (userIdFromState) {
      dispatch(
        updateFormData({ userId: userIdFromState, password: EMPTY_STRING })
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <LoginWrapper>
      <LoginBlock>
        {canShowTryMeBanner && <TryMeBanner />}
        <LoginForm handleSubmit={handleSubmit} />
      </LoginBlock>
      <MainPromoBlock>
        {brandImages.mainPromo[language] && (
          <PromoWrapper data-test="promo-image" />
        )}
      </MainPromoBlock>
    </LoginWrapper>
  )
}

export default LoginContainer
